import React from 'react';
import AnimatedMightyLogo from 'src/elements/AnimatedMightyLogo/AnimatedMightyLogo';
import { LogoContainerLink } from './LogoLink.styles';
import { Color } from 'src/styles/colors';

interface LogoLinkProps {
  isVisible: boolean;
  color?: Color;
  clickable?: boolean;
}

const LogoLink = ({ isVisible, color = 'greyText', clickable = true }: LogoLinkProps): JSX.Element => (
  <LogoContainerLink
    to='/'
    logoColor={color}
    clickable={clickable}
  >
    {isVisible && (
      <AnimatedMightyLogo
        isAnimated
        logoAnimationTransitionInMilliseconds={50}
      />
    )}
  </LogoContainerLink>
);

export default LogoLink;
